import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../00-MAIN/00-CONTEXT/AuthContext";
import Overview from "../01-PROFIL/01-MAIN/ProfilePage";
import PlanUpskilling from "../03-COMPTENCES/01-MAIN/PlanUpskilling";
import ObjectifsSmart from "../05-OBJECTIFS/01-MAIN/ObjectivesSummary";

const tabs = [
    "Profil",
    "Compétences",
    "Objectifs"
];

function EspacePersonnelApp() {
    const navigate = useNavigate();
    const { user, isAuthenticated, loading: authLoading, error: authError } = useAuth();

    // Initialize activeTab from localStorage or default to "Profil"
    const [activeTab, setActiveTab] = useState(() => {
        const savedTab = localStorage.getItem('espacePersonnelActiveTab');
        return savedTab && tabs.includes(savedTab) ? savedTab : tabs[0];
    });
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (!isAuthenticated) {
            navigate("/login");
            return;
        }
        setLoading(false);
    }, [isAuthenticated, navigate]);

    // Save the activeTab to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('espacePersonnelActiveTab', activeTab);
    }, [activeTab]);

    if (authLoading || loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#18574F] mx-auto"></div>
                    <p className="mt-4 text-gray-600">Chargement...</p>
                </div>
            </div>
        );
    }

    if (authError) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="text-center text-red-500">
                    <div className="text-6xl mb-4">⚠️</div>
                    <p className="text-lg mb-4">Erreur: {authError}</p>
                    <button
                        onClick={() => navigate("/login")}
                        className="bg-blue-500 text-white px-6 py-3 rounded-md hover:bg-blue-600 transition-colors"
                    >
                        Retour à la connexion
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full p-1 bg-gray-100">
            <div className="bg-white p-6 rounded shadow-md flex-1 overflow-auto">
                {/* Onglets alignés avec la sidebar */}
                <div className="flex space-x-2 mb-4 -mt-4">
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`
                px-3 py-1.5 rounded text-xs font-medium transition-all duration-150 border-2 !text-black
                ${activeTab === tab
                                    ? "bg-[#95aca9] shadow-sm border-gray-300"
                                    : "bg-gray-100 hover:bg-[#95aca9] border-gray-300 hover:border-gray-300"
                                }
              `}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Contenu dynamique selon l'onglet */}
                <div className="min-h-[600px]">
                    {activeTab === "Profil" && <Overview user={user} />}
                    {activeTab === "Compétences" && <PlanUpskilling />}
                    {activeTab === "Objectifs" && <ObjectifsSmart />}
                </div>
            </div>
        </div>
    );
}

export default EspacePersonnelApp;